import React from "react";
import {TopMenuBar} from "../components/TopMenuBar/TopMenuBar";
import NewPackoutBox from "../components/NewPackoutBox/NewPackoutBox";
import "./style.css";
import "@fontsource-variable/open-sans";
import * as Utils from '../Utils';

export const NewPackOutPage = () => {
  
  Utils.cleanUp()
  localStorage.setItem('lastLoadOut', 0);

  function redirect(){}
  return (
    <div className="menu-landing">
      <div className="overlap-group">
        <TopMenuBar/>
        <NewPackoutBox
            open={true}
            onSubmit={()=>redirect()}>
        </NewPackoutBox>
      </div>
    </div>
  );
};

export default NewPackOutPage;